<template>
  <div class="protocol loan-contact-protocol">
    <navigation >借 款 合 同</navigation>
    <div class="protocol">
      <loan></loan>
      <p data-sensors-exposure-property-page_status="page_bottom" data-sensors-exposure-event-name="general_event">&nbsp;<!-- 监听协议滑动到了底部，每个协议都加上--></p>
    </div>
    <p
      data-sensors-exposure-property-page_status="page_bottom"
      data-sensors-exposure-event-name="general_event"
    >&nbsp;<!-- 监听协议滑动到了底部，每个协议都加上--></p>
  </div>
</template>

<script>
import underline from '../tmd/underline'
export default {
  name: 'loan-contact-protocol',

  components: {
    underline,
    loan: () => import('@/view/protocol/components/loan.vue')
  },
  created () {
    this.$bus.$emit('ready')
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
            
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/mixin.less";

    .loan-contact-protocol {
        width: 100%;
        position: relative;

        .table {
          width: 100%;
          margin-top: 20px;
          border-collapse: collapse;
          border: 2px solid #000;
          overflow-y: auto;
          td {
            border: 2px solid #000;
            text-align: center;
            min-width: 50px;
            .tab-2 {
              text-indent: 0 !important;
            }
          a {
            word-break: break-all;
          }
          }
        }

        .bolder {
            font-weight: bolder;
        }
        .text {
          text-indent: 40px;
        }
        .text:last-child {
            margin-bottom: 100px;
        }
        .tab-0 {
            text-indent: 0;
        }
        .underline {
            text-indent: 200px;
            text-decoration: underline;
        }
        .underline:last-child {
            margin-bottom: 100px;
        }
      }
</style>
